'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "roles_and_education",
    "tab": "Financial Services Roles",
    "columns": [
      {
        "id": "4699",
        "image": {
          "url": "http://placeimg.com/300/300/animals",
          "title": "Photo Title",
          "alt": "Photo alt"
        }
      },
      {
        "id": "4693",
        "image": {
          "url": "http://placeimg.com/300/300/animals",
          "title": "Photo Title",
          "alt": "Photo alt"
        }
      },
      {
        "id": "4692",
        "image": {
          "url": "http://placeimg.com/300/300/animals",
          "title": "Photo Title",
          "alt": "Photo alt"
        }
      }
    ],
  }

  Footer module for roles and education.

  Pass an array of columns, where `id` matches
  the subsector ID, and `image` is the image to show.
*/

function RolesAndEducation(_ref) {
  var moduleClass = _ref.moduleClass,
      columns = _ref.columns,
      hasMatched = _ref.hasMatched,
      matchMe = _ref.matchMe;

  return _react2.default.createElement(
    'div',
    {
      className: 'tab-content type-roles_and_education ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      { className: 'columns three-columns' },
      columns.map(function (_ref2, key) {
        var title = _ref2.title,
            image = _ref2.image,
            jobs = _ref2.jobs;
        return _react2.default.createElement(_Column2.default, {
          key: key,
          title: title,
          image: image,
          jobs: jobs,
          hasMatched: hasMatched,
          matchMe: matchMe
        });
      })
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(RolesAndEducation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/RolesAndEducation/RolesAndEducation.jsx
// module id = 1261
// module chunks = 0